import React, { FC } from 'react';
import * as S from './styles';

export type HeaderFeature = 'my-words' | 'my-activities';

export const HeaderFeatureIntro: FC<{
  feature: HeaderFeature;
}> = ({ feature }) => {
  return (
    <S.Wrapper>
      <S.HeaderIcon name="statistics" $active={feature === 'my-activities'} />
      <S.HeaderIcon name="book" $active={feature === 'my-words'} />
      <S.HeaderIcon name="fire" />
      <S.ProfileIcon name="profileIcon" />
    </S.Wrapper>
  );
};
